import { render, staticRenderFns } from "./echart-pielab.vue?vue&type=template&id=6b28995c&scoped=true&"
import script from "./echart-pielab.vue?vue&type=script&lang=js&"
export * from "./echart-pielab.vue?vue&type=script&lang=js&"
import style0 from "./echart-pielab.vue?vue&type=style&index=0&id=6b28995c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28995c",
  null
  
)

export default component.exports